"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = exports.ModalContainer = exports.Modal = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Modal = native_1.default.Modal `
  flex: 1 0 0;
  width: 100%;
`;
exports.ModalContainer = native_1.default.View `
  flex: 1 0 0;
  width: 100%;
  background-color: ${(p) => p.backgroundColor ? p.backgroundColor : 'rgba(0, 0, 0, 0.41)'};
  justify-content: center;
  padding: ${({ customPadding = 0 }) => customPadding};
`;
exports.ModalContent = native_1.default.View `
  width: 100%;
  border-radius: 9px;
  background-color: ${(p) => p.fullWidthVisible ? p.theme.color.white : 'transparent'};
  shadow-color: ${(p) => p.theme.color.black};
  shadow-offset: 0 0;
  shadow-opacity: 0.11;
  shadow-radius: 6px;
  elevation: 10;
`;
